import { CloseOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { IssueCaseDoc } from '@gooduncles/gu-app-schema';
import { Tag } from 'antd';
import { FC } from 'react';

import { issueCaseCategoryKr } from 'src/constants/issue.constants';
import { formatBadgeDate } from 'src/utils/date-util';

import classes from './CreateFormSection.module.scss';

interface LinkedIssueCaseBadgeProps {
  issueCase: IssueCaseDoc;
  onRemove: () => void;
}

const LinkedIssueCaseBadge: FC<LinkedIssueCaseBadgeProps> = ({ issueCase, onRemove }) => {
  const categoryLabel = issueCaseCategoryKr[issueCase.category] ?? issueCase.category;

  return (
    <div className={classes.linkedOrderBadge}>
      <Tag
        icon={<ExclamationCircleOutlined />}
        color='orange'
        closable
        closeIcon={<CloseOutlined />}
        onClose={onRemove}
        style={{ marginRight: 0 }}>
        [이슈] {categoryLabel} {formatBadgeDate(issueCase.registeredAt)}
      </Tag>
    </div>
  );
};

export default LinkedIssueCaseBadge;
